/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Invalid_SeatInputs */



/**
* | output |
* | --- |
* | "Invalid seat number" |
*
* @param {Err_Tournament_Invalid_SeatInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_invalid_seat = /** @type {((inputs?: Err_Tournament_Invalid_SeatInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Invalid_SeatInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Numéro de siège invalide")
	if (locale === "es") return /** @type {LocalizedString} */ ("Número de asiento no válido")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Número de assento inválido")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero di posto non valido")
	return /** @type {LocalizedString} */ ("Invalid seat number")
});